import { getStringAnchorProperties, removeLoadSpinner, ISettings } from './rms-ui.navi';

/** 
 * ======================================================================== 
 * RMS Footer
 * ======================================================================== 
 */
/** Initialize Footer module (add default classes & render copyright) */
export function initFooterModule(settings: ISettings, target: string) {
  const { classNames } = settings.footer;
  const footer = document.querySelector(target as string);
  for (const className of classNames) if (!footer.classList.contains(className)) footer.classList.add(className);
  try {
    if (footer) footer.innerHTML += renderFooterCopyright(settings.footer);
  } catch (error) {
    throw error;
  }
}

/** Render Footer */
export function renderFooter(settings: ISettings, data?: IFooterList[]) {
  const { target } = settings.footer;
  const footer = document.querySelector(target as string);
  try {
    removeLoadSpinner(settings, footer);
    if (!footer || !data) return;
    footer.innerHTML = '';
    const listContent = data.map(list => renderFooterList(settings.footer, list)).join('');
    footer.innerHTML = `${listContent}${renderFooterCopyright(settings.footer)}`;
  } catch (error) {
    throw error;
  }
}

/** Render Footer List */
function renderFooterList(settingsFooter: IFooter, data: IFooterList): string {
  const { separator } = settingsFooter;
  if (!data.canAccess) return '';
  const sep = separator === undefined ? '' : separator;
  const list: string[] = [];
  list.push(`<li>${data.title.join('<br/>')}${sep}</li>`);
  for (const item of data.list) {
    if (!item.canAccess) continue;
    list.push(`<li><a ${getStringAnchorProperties(item)}>${item.title.join('<br/>')}</a></li>`);
  }
  return `<ul class="rms-footer-list">${list.join('')}</ul>`;
}

/** Render Footer's Copyright section */
function renderFooterCopyright(settingsFooter: IFooter): string {
  const { copyrightTexts } = settingsFooter;
  return copyrightTexts ? `<p class="small">${copyrightTexts.map(text => `<span>${text}</span>`).join('')}</p>` : '';
}

export interface IFooter {
  target: string;
  classNames: string[];
  copyrightTexts?: string[];
  separator?: string;
}

export interface IFooterList {
  canAccess: boolean
  id: string;
  list: IFooterListItem[];
  newTab: boolean;
  title: string[];
}

interface IFooterListItem {
  canAccess: boolean
  id: string;
  newTab: boolean;
  title: string[];
  url: string;
}